import { forwardRef, createElement } from 'react';

function IconAttachAuto(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M7.916 10.159l1.06 1.06-2.663 2.665a3.75 3.75 0 005.159 5.44l.144-.137 6.657-6.657a.75.75 0 011.128.984l-.067.077-6.657 6.657a5.25 5.25 0 01-7.575-7.269l.15-.156 2.664-2.664zm11.771-6.468a3.75 3.75 0 01.137 5.16l-.137.144-9.132 9.132a2.25 2.25 0 01-3.287-3.07l.105-.112 6.657-6.657a.75.75 0 011.128.984l-.067.076-6.657 6.657a.75.75 0 00.984 1.128l.077-.067 9.132-9.132a2.25 2.25 0 00-3.07-3.287l-.112.105-2.933 2.932-1.061-1.061 2.933-2.932a3.75 3.75 0 015.303 0zM4 9a2 2 0 002 2 2 2 0 00-1.995 1.85L4 13l-.004-.132A2 2 0 002 11a2 2 0 002-2zm6-2.5a2 2 0 002 2 2 2 0 00-1.995 1.85L10 10.5l-.004-.132A2 2 0 008 8.5a2 2 0 002-2zM6.5 2c0 2.21 2.015 4 4.5 4-2.412 0-4.381 1.687-4.495 3.806L6.5 10l-.01-.263C6.338 7.65 4.386 6 2 6c2.485 0 4.5-1.79 4.5-4z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var AttachAuto = /*#__PURE__*/forwardRef(IconAttachAuto);

export default AttachAuto;
//# sourceMappingURL=AttachAuto.js.map
